/**
 * Mobile Menu Fix
 * 
 * This script fixes an issue where the mobile menu doesn't open on the cart page
 * and product pages when items are in the cart.
 */

(function() {
  document.addEventListener("DOMContentLoaded", function() {
    // Get the mobile nav toggle button
    var mobileNavToggle = document.querySelector('.js-mobile-nav-toggle');
    if (!mobileNavToggle) return;
    
    // Remove the original click event by cloning the button
    var newMobileNavToggle = mobileNavToggle.cloneNode(true);
    mobileNavToggle.parentNode.replaceChild(newMobileNavToggle, mobileNavToggle);
    
    // Add our own click handler
    newMobileNavToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Get necessary elements
      var mobileNavContainer = document.querySelector('.mobile-nav-wrapper');
      var pageContainer = document.querySelector('#PageContainer');
      var siteHeader = document.querySelector('.site-header');
      
      // Check if menu is already open
      var mobileNavIsOpen = newMobileNavToggle.classList.contains('mobile-nav--close');
      
      // Also toggle the header class (from custom.js functionality)
      document.querySelector('header').classList.toggle('nav-open');
      
      if (mobileNavIsOpen) {
        // Close the mobile nav
        mobileNavContainer.classList.remove('js-menu--is-open');
        mobileNavContainer.style.transform = 'translateY(-100%)';
        newMobileNavToggle.classList.remove('mobile-nav--close');
        newMobileNavToggle.classList.add('mobile-nav--open');
        newMobileNavToggle.setAttribute('aria-expanded', false);
        pageContainer.setAttribute('style', '');
        
        // Remove ESC key handler
        window.removeEventListener('keyup', escKeyHandler);
      } else {
        // Open the mobile nav
        var translateHeaderHeight = siteHeader.offsetHeight;
        
        // Load mobile menu content if needed
        if (typeof theme !== 'undefined' && 
            typeof theme.MobileNav !== 'undefined' && 
            document.getElementById('mobile_menu_top') && 
            document.getElementById('MobileNav')) {
          var mobileNavInner = document.getElementById('MobileNav').innerHTML;
          document.getElementById('MobileNav').innerHTML = 
            document.getElementById('mobile_menu_top').innerHTML + mobileNavInner;
        }
        
        mobileNavContainer.classList.add('js-menu--is-open');
        mobileNavContainer.style.transform = 'translateY(' + translateHeaderHeight + 'px)';
        newMobileNavToggle.classList.add('mobile-nav--close');
        newMobileNavToggle.classList.remove('mobile-nav--open');
        newMobileNavToggle.setAttribute('aria-expanded', true);
        
        // Add ESC key handler
        window.addEventListener('keyup', escKeyHandler);
        
        // Initialize sub-nav toggle buttons if they exist
        var subNavToggleBtns = document.querySelectorAll('.mobile-nav__toggle-btn');
        if (subNavToggleBtns.length > 0) {
          subNavToggleBtns.forEach(function(btn) {
            btn.addEventListener('click', function() {
              var toggleBtn = this;
              var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
              
              toggleBtn.setAttribute('aria-expanded', !isExpanded);
              toggleBtn.nextElementSibling.classList.toggle('is-open');
            });
          });
        }
      }
    });
    
    // ESC key handler function
    function escKeyHandler(event) {
      if (event.which === 27) {
        var mobileNavToggle = document.querySelector('.js-mobile-nav-toggle');
        if (mobileNavToggle) {
          mobileNavToggle.click();
        }
      }
    }
  });
})();
